import "assets/scss/layouts/qiosk.scss";
import React, { useEffect } from "react";
import { useApp } from "context";
import { Outlet } from "react-router-dom";
import { Constants, Helpers } from "utils";
import { Custom } from "components";

type Props = {};

export const QioskLayout = (props: Props) => {
  const { setFeedback, feedback, theme } = useApp();
  const hasMessage = feedback && Helpers.hasValue(feedback.message);

  useEffect(() => {
    if (hasMessage) {
      const timeout = setTimeout(
        () => setFeedback(null),
        Constants.REFRESH_RATE.ALERT
      );
      return () => clearTimeout(timeout);
    }
  }, [hasMessage]);

  return (
    <>
      <div
        className="qh-qiosk"
        style={{
          color: theme.palette.font.color,
          backgroundColor: theme.palette.background.color,
        }}
      >
        <div className="qh-container">
          <div className="qh-header">
            {hasMessage && (
              <Custom.Alert
                variant="filled"
                severity={feedback?.severity ?? undefined}
              >
                <span style={{ fontSize: "1.5em" }}>{feedback?.message}</span>
              </Custom.Alert>
            )}
          </div>
          <div
            className="qh-content"
            style={{
              color: theme.palette.font.accent,
              backgroundColor: theme.palette.background.accent,
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};
